function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { white, grey3, boxShadowRaised, boxShadowDetached, boxShadowOverlaid, boxShadowPoppedOut } from "../../../eden-style-constants";
const boxShadowsByDepth = {
  raised: boxShadowRaised,
  detached: boxShadowDetached,
  overlaid: boxShadowOverlaid,
  poppedOut: boxShadowPoppedOut
};
const Container = styled.div.withConfig({
  componentId: "sc-14wiswp-0"
})(["background-color:", ";border:1px solid ", ";border-radius:2px;box-shadow:", ";"], white, grey3, props => boxShadowsByDepth[props.depth]);

const Card = ({
  children,
  depth = "raised",
  ...props
}) => /*#__PURE__*/React.createElement(Container, _extends({
  depth: depth
}, props), children);

export default Card;
const depths = Object.keys(boxShadowsByDepth);
Card.propTypes = {
  /** Content to render inside the Card */
  children: PropTypes.node.isRequired,

  /** How the card should be rendered relative to surrounding layers */
  depth: PropTypes.oneOf(depths)
};